/*switch the entire card-product based on selected individual product swatch*/
window.initCardProductSwitch = function () {
  document.querySelectorAll('.card-wrapper .color-swatch-button').forEach(button => {
    // Prevent duplicate listeners
    if (button.dataset.listenerAttached === "true") return;

    button.dataset.listenerAttached = "true";

    button.addEventListener('click', function () {
      const handle = this.dataset.productHandle;
      const currentCard = this.closest('.card-wrapper.product-card-wrapper');

      if (!handle || !currentCard) {
        console.warn('Missing product handle or .card-wrapper.product-card-wrapper');
        return;
      }

      fetch(`/products/${handle}?section_id=card-product-section`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCard = doc.querySelector('[data-product-wrapper]');

          if (newCard) {
            currentCard.replaceWith(newCard);

            // Re-init logic
            if (typeof window.initQuickAdd === 'function') {
              window.initQuickAdd(newCard);
            }
            if (typeof window.initNotifyMeForm === 'function') {
              window.initNotifyMeForm();
            }

            if (typeof window.initCardProductSwitch === 'function') {
              window.initCardProductSwitch(); // re-bind
            }
            if (typeof window.initQuickAddBySize === 'function') {
              window.initQuickAddBySize(); // re-bind
            }
            if (typeof window.initCardMediaCarousel === 'function') {
              window.initCardMediaCarousel(); // re-bind
            }
          } else {
            console.warn('New card-product not found in loaded HTML.');
          }
        })
        .catch(err => {
          console.error(`❌ Failed to load section for ${handle}`, err);
        });
    });
  });
};

// ✅ Run on initial load
document.addEventListener('DOMContentLoaded', function () {
  window.initCardProductSwitch();
});

/*switch the entire card-product based on selected individual product swatch*/


/*Custom quick add on card-product.liquid*/
function initQuickAdd(scope = document) {
  scope.querySelectorAll('.card-product').forEach(productCard => {
    const handle = productCard.dataset.productHandle;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(productData => {
        // Trigger initial selection
        productCard.querySelectorAll('.variant-swatch[aria-current="true"]').forEach(swatch => swatch.click());

        productCard.querySelectorAll('.variant-swatch').forEach(swatch => {
          swatch.addEventListener('click', function () {
            const swatchGroup = this.closest('.variant-swatches');
            const optionIndex = parseInt(this.dataset.optionIndex, 10);

            // Update UI selection
            swatchGroup.querySelectorAll('.variant-swatch').forEach(btn => btn.removeAttribute('aria-current'));
            this.setAttribute('aria-current', 'true');

            // Build selection
            const selectedOptions = [];
            productCard.querySelectorAll('.variant-swatches').forEach((group, i) => {
              const selected = group.querySelector('[aria-current="true"]');
              selectedOptions[i] = selected ? selected.dataset.value : null;
            });

            const form = productCard.querySelector('form');
            const variantIdInput = form.querySelector('input[name="id"]');
            const addButton = form.querySelector('.quick-add-button');

            // Match correct variant
            const matchedVariant = productData.variants.find(v =>
              v.options.every((opt, idx) => !selectedOptions[idx] || opt === selectedOptions[idx])
            );

            if (matchedVariant) {
              variantIdInput.value = matchedVariant.id;

              if (matchedVariant.available) {
                addButton.classList.remove('disabled');
                addButton.querySelector('.button-text').textContent = 'Add to cart';
              } else {
                addButton.classList.add('disabled');
                addButton.querySelector('.button-text').textContent = 'Sold out';
              }
            }

            // Update availability for all swatches
            productCard.querySelectorAll('.variant-swatches').forEach((group, groupIndex) => {
              group.querySelectorAll('.variant-swatch').forEach(btn => {
                const testOptions = [...selectedOptions];
                testOptions[groupIndex] = btn.dataset.value;

                const isAvailable = productData.variants.some(v =>
                  v.available && v.options.every((opt, idx) => !testOptions[idx] || opt === testOptions[idx])
                );

                btn.classList.toggle('disabled', !isAvailable);
              });
            });

            // Update visible selected label
            const label = swatchGroup.closest('.variant-option')?.querySelector('.variant-option__label .selected-value');
            if (label) label.textContent = this.dataset.value;
          });
        });
      })
      .catch(err => {
        console.error(`❌ Failed to fetch product ${handle}`, err);
      });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  window.initQuickAdd();
});
/*Custom quick add on card-product.liquid*/

// Reinitiate product switch and quick add function when filtered
const observer = new MutationObserver(() => {
  console.log('🟢 Mutation detected – reinitializing');
  
  if (typeof window.initCardProductSwitch === 'function') {
    window.initCardProductSwitch();
  }


  if (typeof window.initNotifyMeForm === 'function') {
    window.initNotifyMeForm();
  }

  if (typeof window.initQuickAdd === 'function') {
    window.initQuickAdd();
  }
  if (typeof window.initCardMediaCarousel === 'function') {
    window.initCardMediaCarousel();
  }
  if (typeof window.initQuickAddBySize === 'function') {
    window.initQuickAddBySize();
  }
  
});

// Grab both elements: by ID and tag name
const targets = [
  document.getElementById('FacetFiltersFormMobile'),
  document.querySelector('product-recommendations')
];

targets.forEach((target) => {
  if (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
    console.log(`👁️ Observing ${target.tagName || target.id}`);
  } else {
    console.warn(`❌ Could not find target to observe`);
  }
});
// Reinitiate product switch and quick add function when filtered

//FAQ toggle on product page
  window.initFAQAccordion = function () {
    document.querySelectorAll(".faq-toggle").forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const answer = toggle.nextElementSibling;
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";

        toggle.setAttribute("aria-expanded", String(!isExpanded));
        answer.classList.toggle("open", !isExpanded);
      });
    });
  };
// Auto-run on initial load
document.addEventListener("DOMContentLoaded", window.initFAQAccordion);
//FAQ toggle on product page

//TABS toggle on product page
window.initAccordion = function () {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.accordion-header');
    const icon = item.querySelector('.accordion-icon');
    const content = item.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      // Close all
      items.forEach(i => {
        i.classList.remove('open');
        i.querySelector('.accordion-content').style.maxHeight = null;
      });

      // Reopen if it wasn't already open
      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // Handle default open state
    if (item.classList.contains('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
};

// Auto-run on initial load
document.addEventListener("DOMContentLoaded", window.initAccordion);
//TABS toggle on product page

//wishcard message toggle
window.initWishCardToggle = function () {
  const checkbox = document.getElementById("toggle_wish_card");
  const messageBox = document.getElementById("wish_card_container");

  if (checkbox && messageBox) {
    checkbox.addEventListener("change", function () {
      messageBox.style.display = this.checked ? "block" : "none";
    });

    // Optional: set initial state on load
    messageBox.style.display = checkbox.checked ? "block" : "none";
  }
};


  // Auto-run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    window.initWishCardToggle();
  });

//End of wishcard message toggle

// Size guide JS (UPDATED for NEW metaobject list: custom.product_size_guide)
// Requirements met:
// - Tabs are dynamic (no Men/Women/Unisex hardcode)
// - Each tab label comes from metaobject field: size_tab_label
// - Each tab content uses metaobject JSON: size_table (render as table) OR desktop/mobile image (image priority)
// - Inch/cm conversion controlled per tab by metaobject boolean: inch_to_cm

window.initSizeGuide = function () {
  const container = document.querySelector(".size-chart-content");
  if (!container) return;

  // --------- Helpers (unchanged / reused) ---------
  const toInches = (value) => {
    if (!value || value.trim() === "-" || value.trim() === "") return value;
    const parts = value.split(/–|-/).map((p) => p.trim());
    return parts
      .map((p) => {
        const num = parseFloat(p);
        return isNaN(num) ? p : (num / 2.54).toFixed(1);
      })
      .join(" – ");
  };

  function ensureEqualWidthStylesInserted() {
    if (document.getElementById("size-guide-equal-width-css")) return;
    const style = document.createElement("style");
    style.id = "size-guide-equal-width-css";
    style.textContent = `
      .size-guide-table.equal-cols { table-layout: fixed; width: 100%; }
      .size-guide-table.equal-cols thead th,
      .size-guide-table.equal-cols tbody td { width: calc(100% / var(--col-count)); }

      /* How to measure layout (text left, image right) */
      .size-guide-howto {
        display: flex;
        gap: 30px;
        margin-top: 24px;
        align-items: flex-start;
      }
      .size-guide-howto__text {
        flex: 1 1 60%;
        min-width: 0;
      }
      .size-chart-content h2 {
          font-size: 16px;
          font-weight: bold;
      }
      .size-guide-howto__image {
        flex: 0 0 40%;
        max-width: 320px;
        width: 100%;
      }
      .size-guide-howto__image img {
        width: 100%;
        height: auto;
        display: block;
      }
      @media (max-width: 749px) {
        .size-guide-howto {
          flex-direction: column;
          gap: 16px;
        }
        .size-guide-howto__image {
          max-width: 100%;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function renderTableFromJSON(containerEl, jsonRaw) {
    try {
      const data = typeof jsonRaw === "string" ? JSON.parse(jsonRaw) : jsonRaw;

      let columns = data?.columns || data?.headers;
      let rows = data?.rows;

      if (!columns || !rows) throw new Error("Invalid table structure");

      if (Array.isArray(rows) && Array.isArray(rows[0])) {
        rows = rows.map((arr) => {
          const obj = {};
          columns.forEach((col, i) => (obj[col] = arr[i] ?? ""));
          return obj;
        });
      }

      ensureEqualWidthStylesInserted();

      const table = document.createElement("table");
      table.className = "size-guide-table equal-cols";

      const thead = document.createElement("thead");
      const trh = document.createElement("tr");
      columns.forEach((col) => {
        const th = document.createElement("th");
        th.textContent = col;
        trh.appendChild(th);
      });
      thead.appendChild(trh);
      table.appendChild(thead);

      table.style.setProperty("--col-count", String(columns.length));

      const tbody = document.createElement("tbody");
      rows.forEach((rowObj) => {
        const tr = document.createElement("tr");
        columns.forEach((col, i) => {
          const td = document.createElement("td");
          const value = rowObj && rowObj[col] ? String(rowObj[col]) : "";
          td.setAttribute("data-cm", value);
          td.textContent = value;
          if (i !== 0) td.setAttribute("data-original", value);
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      containerEl.innerHTML = "";
      containerEl.appendChild(table);
    } catch (e) {
      console.error("❌ Error rendering size table:", e);
      containerEl.textContent = "Unable to load size chart.";
    }
  }

  function updateUnit(containerEl, unit = "cm") {
    const table = containerEl.querySelector(".size-guide-table");
    if (!table) return;

    const headers = Array.from(table.querySelectorAll("thead th"));

    const skipColumnIndexes = new Set();
    headers.forEach((th, index) => {
      const t = th.textContent.trim().toLowerCase();

      const normalized = t
        .replace(/\(.*?\)/g, "")   // remove anything in parentheses e.g. (cm)
        .trim();

      if (["euro", "eu","eur", "uk", "us", "label", "us women", "us men", "jp", "chn"].includes(normalized)) {
        skipColumnIndexes.add(index);
      }

      const upper = th.textContent.trim().toUpperCase();
      if (upper === "CM" || upper === "INCH") {
        th.textContent = unit === "in" ? "INCH" : "CM";
      }
    });

    const rows = table.querySelectorAll("tbody tr");

    rows.forEach((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));

      cells.forEach((cell, index) => {
        if (skipColumnIndexes.has(index)) return;

        let originalValue =
          cell.getAttribute("data-original") ||
          cell.getAttribute("data-cm") ||
          cell.textContent.trim();

        if (!cell.getAttribute("data-original")) {
          cell.setAttribute("data-original", originalValue);
        }

        if (!/\d/.test(originalValue)) return;

        if (unit === "in") {
          const converted = originalValue.replace(/(\d+(\.\d+)?)/g, (match) => {
            return toInches(match);
          });
          cell.textContent = converted;
        } else {
          cell.textContent = originalValue;
        }
      });
    });
  }

  // --------- Read payload ---------
  const payloadEl = document.getElementById("SizeGuideData");
  if (!payloadEl) {
    console.warn("SizeGuideData payload not found. Please inject JSON payload in Liquid.");
    return;
  }

  let payload;
  try {
    payload = JSON.parse(payloadEl.textContent || "{}");
  } catch (e) {
    console.error("❌ Invalid SizeGuideData JSON", e);
    return;
  }

  const sizes = Array.isArray(payload.sizes) ? payload.sizes : [];
  if (!sizes.length) {
    console.warn("No size entries found in SizeGuideData.");
    return;
  }

  // --------- Build dynamic tabs + panels ---------
  const tabsBar = container.querySelector(".size-chart-tabs");
  const titleEl = container.querySelector(".size-title");
  const panelRoot = container; // panels inside .size-chart-content

  if (!tabsBar) {
    console.warn("Tab bar .size-chart-tabs not found.");
    return;
  }

  tabsBar.innerHTML = "";
  container.querySelectorAll('.tab-content[id^="tab"], .tab-content[id^="size-tab-"]').forEach((el) => el.remove());

  // Always set title to first size name (fallback to label, then default)
  if (titleEl) {
    const first = sizes[0] || {};
    const firstTitle =
      (first.name && String(first.name).trim()) ||
      (first.label && String(first.label).trim()) ||
      "Size Guide";

    titleEl.textContent = firstTitle;
  }

  sizes.forEach((size, idx) => {
    const tabId = `size-tab-${idx}`;

    // --- Tab Button ---
    const btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("data-tab-target", tabId);
    btn.textContent = size?.label ? String(size.label) : `Size ${idx + 1}`;
    tabsBar.appendChild(btn);

    // --- Panel ---
    const panel = document.createElement("div");
    panel.id = tabId;
    panel.className = "tab-content";

    const canConvert = String(size?.inchToCm).toLowerCase() === "true" || size?.inchToCm === true;

    // Added .size-guide-howto block UNDER chart
    panel.innerHTML = `
      <div class="unit-toggle-switch" style="display:none">
        <span class="unit-label inch">Centimetre</span>
        <label class="switch">
          <input type="checkbox" class="unitToggle" />
          <span class="slider"></span>
        </label>
        <span class="unit-label cm">Inch</span>
      </div>

      <div class="sizeGuideTableContainer"></div>

      <div class="size-guide-howto" style="display:none">
        <div class="size-guide-howto__text"></div>
        <div class="size-guide-howto__image"></div>
      </div>
    `;

    panelRoot.appendChild(panel);

    const contentContainer = panel.querySelector(".sizeGuideTableContainer");
    const toggleWrap = panel.querySelector(".unit-toggle-switch");
    const toggle = panel.querySelector(".unitToggle");

    const howWrap = panel.querySelector(".size-guide-howto");
    const howText = panel.querySelector(".size-guide-howto__text");
    const howImgWrap = panel.querySelector(".size-guide-howto__image");

    const desktopImage = (size?.desktopImage || "").trim();
    const mobileImage = (size?.mobileImage || "").trim();
    const hasDesktopImage = desktopImage && desktopImage !== "null" && !desktopImage.startsWith("undefined");
    const hasMobileImage = mobileImage && mobileImage !== "null" && !mobileImage.startsWith("undefined");
    const hasAnyImage = hasDesktopImage || hasMobileImage;

    const tableRaw = typeof size?.table === "string" ? size.table.trim() : size?.table;

    // Clear
    contentContainer.innerHTML = "";

    // Render image or table
    if (hasAnyImage) {
      if (toggleWrap) toggleWrap.style.display = "none";

      const selectedImage =
        window.innerWidth < 740 && hasMobileImage ? mobileImage : desktopImage || mobileImage;

      const img = document.createElement("img");
      img.src = selectedImage;
      img.alt = "Size Guide";
      img.style.width = "100%";
      img.loading = "lazy";

      img.onerror = function () {
        console.warn(`📛 Image failed to load for ${tabId}, falling back to table if exists`);
        contentContainer.innerHTML = "";
        if (tableRaw) {
          if (toggleWrap) toggleWrap.style.display = canConvert ? "" : "none";
          renderTableFromJSON(contentContainer, tableRaw);
        } else {
          contentContainer.textContent = "Unable to load size chart.";
        }
      };

      contentContainer.appendChild(img);
    } else if (tableRaw) {
      if (toggleWrap) toggleWrap.style.display = canConvert ? "" : "none";
      renderTableFromJSON(contentContainer, tableRaw);
    } else {
      if (toggleWrap) toggleWrap.style.display = "none";
      contentContainer.textContent = "No size chart available.";
    }

    // Toggle wiring
    if (canConvert && toggle) {
      toggle.addEventListener("change", function () {
        updateUnit(contentContainer, this.checked ? "in" : "cm");
      });
    }

    // Render "How to measure" underneath (text left, image right)
    const howHtml = (size?.howToMeasure || "").trim(); // already HTML from metafield_tag
    const howImg = (size?.howToMeasureImage || "").trim();

    if (howWrap && (howHtml || howImg)) {
      howWrap.style.display = ""; // show
      if (howText) howText.innerHTML = howHtml || "";
      if (howImgWrap) {
        howImgWrap.innerHTML = howImg ? `<img src="${howImg}" alt="How to measure" loading="lazy">` : "";
      }
    } else if (howWrap) {
      howWrap.style.display = "none";
    }
  });

  // --------- Tab Navigation ---------
  const buttons = container.querySelectorAll("[data-tab-target]");
  const tabs = container.querySelectorAll(".tab-content");

  buttons.forEach((btn) => btn.classList.remove("active"));
  tabs.forEach((tab) => tab.classList.remove("active"));

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("data-tab-target");
      const targetTab = container.querySelector(`#${targetId}`);
      buttons.forEach((btn) => btn.classList.remove("active"));
      tabs.forEach((tab) => tab.classList.remove("active"));
      button.classList.add("active");
      if (targetTab) targetTab.classList.add("active");
    });
  });

  const firstTab = container.querySelector(".tab-content");
  const firstButton = container.querySelector(".size-chart-tabs button");
  if (firstTab) firstTab.classList.add("active");
  if (firstButton) firstButton.classList.add("active");
};

document.addEventListener("DOMContentLoaded", () => {
  window.initSizeGuide();
});

//End Size guide JS

//Display none native color swatch on product page if there is grouped colors metafield
window.initColorSwitcherHider = function () {
  const hasColorSwitcher = document.querySelector('.product__info-wrapper .color-switcher');

  if (hasColorSwitcher) {
    document.querySelectorAll('.product-form__input--swatch').forEach(el => {
      el.style.display = 'none';
    });
  }
};

window.observeVariantSelects = function () {
  const variantWrapper = document.querySelector('variant-selects')?.parentElement;

  if (!variantWrapper) {
    console.warn('⚠️ Cannot observe variant-selects parent');
    return;
  }

  const observer = new MutationObserver(() => {
    console.log('🔄 Variant-selects re-rendered');
    window.initColorSwitcherHider();

    // OPTIONAL: reattach change listener if needed
    const radios = variantWrapper.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', window.initColorSwitcherHider);
    });
  });

  observer.observe(variantWrapper, {
    childList: true,
    subtree: true,
  });
};

// Boot it
document.addEventListener('DOMContentLoaded', () => {
  window.initColorSwitcherHider();
  window.observeVariantSelects();
});
//Display none native color swatch on product page if there is grouped colors metafield

//coming soon subscription
window.initNotifyMeForm = function() {
  document.querySelectorAll('.notify-me-wrapper').forEach(function(wrapper) {
    const button = wrapper.querySelector('.notify-me-button');
    const formWrapper = wrapper.querySelector('.notify-me-form');
    const form = wrapper.querySelector('.notify-me-form-inner');
    const successMessage = wrapper.querySelector('#NotifyMeSuccess');

    if (button && formWrapper && form && successMessage) {
      button.addEventListener('click', function() {
        formWrapper.style.display = 'flex';
        button.style.display = 'none';
        successMessage.style.display = 'none'; // hide success if still showing
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const formData = new FormData(form);
        const formParams = new URLSearchParams(formData);

        fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formParams
        })
        .then(response => {
          if (response.ok) {
            formWrapper.style.display = 'none';
            successMessage.style.display = 'block';

            // Scroll to the closest grid__item
            const gridItem = wrapper.closest('.grid__item') || wrapper.closest('.card-wrapper');
            if (gridItem) {
              gridItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

          } else {
            alert('There was an error. Please try again.');
          }
        })
        .catch(error => {
          console.error(error);
          alert('There was an error. Please try again.');
        });
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.initNotifyMeForm();
});
document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  
  if (params.get('customer_posted') === 'true') {
    // First: clean the URL
    if (history.replaceState) {
      const cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
    }

    // Second: scroll back to the original product card
    const firstNotifyMeForm = document.querySelector('.notify-me-wrapper');
    if (firstNotifyMeForm) {
      const productCard = firstNotifyMeForm.closest('.grid__item') || firstNotifyMeForm.closest('.card-wrapper') || firstNotifyMeForm;
      if (productCard) {
        setTimeout(function() {
          productCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300); // slight delay for smooth scroll
      }
    }
  }
});

//coming soon subscription

//custom quick add size swatch on card product
window.initQuickAddBySize = function () {
  document.querySelectorAll('.product-sizes .size-badge').forEach(button => {
    button.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');

      // stay inside the card wrapper
      const productCard = this.closest('.card-product, .product-card, .card-wrapper');
      if (!productCard) return;

      const hiddenInput  = productCard.querySelector('input[name="id"]');
      const submitButton = productCard.querySelector('.quick-add-button');

      // read UK-size flag from nearest [data-uk-size]
      const wrapperWithUkFlag = productCard.closest('[data-uk-size]');
      const isUkSize =
        wrapperWithUkFlag &&
        wrapperWithUkFlag.getAttribute('data-uk-size') === 'true';

      // Size property input + value from the badge
      const sizePropertyInput = productCard.querySelector('input[name="properties[Size]"]');
      const rawSizeValue =
        this.getAttribute('data-size') ||
        this.getAttribute('data-value') ||
        this.textContent.trim();

      if (variantId && hiddenInput && submitButton) {
        hiddenInput.value = variantId;

        if (sizePropertyInput) {
          if (isUkSize && rawSizeValue) {
            const cleanSize = rawSizeValue.replace(/^UK\s*/i, ''); // strip any existing "UK "
            sizePropertyInput.value = `UK ${cleanSize}`; // show as product note
          } else {
            // non-UK products: clear it so no line item property appears
            sizePropertyInput.value = '';
          }
        }

        submitButton.click();
      }
    });
  });
};

// Auto-run 
document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.initQuickAddBySize === 'function') {
    window.initQuickAddBySize();
  }
});
//custom quick add size swatch on card product

//customize mouse drag on shopify <slider-component>
window.initSliderDrag = function () {
  document.querySelectorAll('slider-component .slider').forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.2; // adjust scroll speed here
      slider.scrollLeft = scrollLeft - walk;
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.initSliderDrag();
});
//customize mouse drag on shopify <slider-component>

//customize slider progress bar on shopify <slider-component>
window.initSliderProgress = function () {
  document.querySelectorAll('slider-component').forEach(slider => {
    const initSingleSlider = (sliderList) => {
      const slides = sliderList ? sliderList.querySelectorAll('li') : [];
      const progressBar = slider.querySelector('.slider-progress-bar');

      if (!sliderList || slides.length === 0 || !progressBar) return;

      const getVisibleItems = () => {
        const classList = sliderList.className;
        if (window.innerWidth <= 749) {
          if (classList.includes('grid--2-col-tablet-down')) return 2;
          if (classList.includes('grid--1-col-tablet-down')) return 1;
        } else {
          if (classList.includes('grid--4-col-desktop')) return 4;
          if (classList.includes('grid--3-col-desktop')) return 3;
          if (classList.includes('grid--2-col-desktop')) return 2;
          if (classList.includes('grid--1-col-desktop')) return 1;
        }
        return 1;
      };

      let visibleItems = getVisibleItems();
      let liWidth = slides[0]?.offsetWidth || 1;

      const updateProgressBar = () => {
        const scrollLeft = sliderList.scrollLeft;
        const maxScrollLeft = sliderList.scrollWidth - sliderList.clientWidth;
        const percent = maxScrollLeft > 0 ? Math.min(scrollLeft / maxScrollLeft, 1) * 100 : 0;
        progressBar.style.width = `${percent}%`;
      };

      // Reset scroll position and progress bar to 0
      const resetSlider = () => {
        sliderList.scrollLeft = 0;
        progressBar.style.width = '0%';
      };

      resetSlider(); // Reset when initializing

      // Recalculate on resize
      window.addEventListener('resize', () => {
        visibleItems = getVisibleItems();
        liWidth = slides[0]?.offsetWidth || 1;
        updateProgressBar();
      });

      // Click to scroll next/prev
      slider.addEventListener('click', (e) => {
        if (e.target.closest('[name="next"]')) {
          sliderList.scrollBy({ left: liWidth, behavior: 'smooth' });
        }
        if (e.target.closest('[name="previous"]')) {
          sliderList.scrollBy({ left: -liWidth, behavior: 'smooth' });
        }
      });

      // Scroll event updates the progress bar
      sliderList.addEventListener('scroll', () => {
        updateProgressBar();
      });
    };

    // Init all <ul> inside this slider-component
    slider.querySelectorAll('ul').forEach(sliderList => {
      initSingleSlider(sliderList);
    });
  });
};

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  window.initSliderProgress();
});

// Re-run and reset when tab is clicked
document.querySelectorAll('[role="tab"]').forEach(tab => {
  tab.addEventListener('click', () => {
    setTimeout(() => {
      document.querySelectorAll('slider-component ul').forEach(sliderList => {
        sliderList.scrollLeft = 0;
      });
      document.querySelectorAll('.slider-progress-bar').forEach(progressBar => {
        progressBar.style.width = '0%';
      });
      window.initSliderProgress();
    }, 200); // small delay after tab switching
  });
});

//customize slider progress bar on shopify <slider-component>

//upsell collection on cart drawer

// Bind size badge clicks properly
document.addEventListener('click', function (e) {
  const button = e.target.closest('.cart-upsell .size-badge');
  if (!button) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const upsellCard = button.closest('.cart-upsell-card');
  if (!upsellCard) return;

  // Highlight selected
  upsellCard.querySelectorAll('.size-badge').forEach(b => b.classList.remove('selected'));
  button.classList.add('selected');

  // Update hidden input
  const productForm = upsellCard.querySelector('product-form');
  const actualForm = productForm?.querySelector('form');
  const hiddenInput = actualForm?.querySelector('input[name="id"]');
  if (!productForm || !actualForm || !hiddenInput) return;

  hiddenInput.value = variantId;

  // Submit the form (Shopify native AJAX)
  const submitButton = actualForm.querySelector('button[type="submit"]');
  if (submitButton) {
    submitButton.click(); // native submission = no redirect
  }
});

//swiper on cart drawer

//card product image carousel
// window.initCardMediaCarousel = function () {
//   document.querySelectorAll('.card-media-carousel').forEach((carousel) => {
//     if (carousel.classList.contains('swiper-initialized')) return;

//     const swiper = new Swiper(carousel, {
//       slidesPerView: 1,
//       loop: true,
//       navigation: {
//         nextEl: carousel.querySelector('.swiper-button-next'),
//         prevEl: carousel.querySelector('.swiper-button-prev'),
//       },
//       on: {
//         init: () => {
//           // Force all slides to have width 100%
//           carousel.querySelectorAll('.swiper-slide').forEach(slide => {
//             slide.style.width = '100%';
//           });
//         },
//         slideChange: () => {
//           // Reapply in case Swiper overrides it
//           carousel.querySelectorAll('.swiper-slide').forEach(slide => {
//             slide.style.width = '100%';
//           });
//         }
//       }
//     });
//   });
// };

// document.addEventListener('DOMContentLoaded', () => {
//   window.initCardMediaCarousel();
// });

//card product image carousel

//*indonesia redirect localization form */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.disclosure__link[data-value]');
    if (!link) return;

    const selectedCountry = link.dataset.value;

    if (selectedCountry === 'ID') {
      e.preventDefault(); // Prevent default Shopify localization logic
      window.location.href = 'https://bybrik.id/';
    }
  });

//*indonesia redirect localization form*/

/*currency converter*/
//when clicked on a country localization form, simulate a click on the app currency converter to click on the new currency
const mapCountryToCurrency = {
  'Malaysia': 'MYR',
  'Singapore': 'SGD'
};

function getSelectedCountry() {
  const el = document.querySelector('.disclosure__link[aria-current="true"] .country');
  return el?.textContent.trim();
}

function getCurrentCurrencyCode() {
  const active = document.querySelector('.glc-list-item__active');
  return active?.getAttribute('glc-code');
}

function switchCurrencyIfNeeded() {
  const selectedCountry = getSelectedCountry();
  const expectedCurrency = mapCountryToCurrency[selectedCountry];
  if (!expectedCurrency) return;

  const currentCurrency = getCurrentCurrencyCode();
  if (currentCurrency === expectedCurrency) return;

  const target = document.querySelector(`.glc-list-item[glc-code="${expectedCurrency}"]`);
  if (target) {
    target.click();
    console.log(`Switched to ${expectedCurrency} for ${selectedCountry}`);
  }
}


// 👀 Observe changes to the country list
const targetNode = document.querySelector('.countries');
if (targetNode) {
  const observer = new MutationObserver(() => {
    switchCurrencyIfNeeded();
  });

  observer.observe(targetNode, {
    attributes: true,
    childList: true,
    subtree: true
  });
}

// 🕐 Run after a short delay (ensures DOM is ready even after AJAX load)
window.addEventListener('load', () => {
  setTimeout(switchCurrencyIfNeeded, 500); // Adjust if needed
});
/*currency converter*/

/* size conversion script product page requires two copies another one is in size-conversion.liquid - make sure same coding */
  /* ---- Size Conversion Script ---- */
window.initSizeConversion = function (opts) {
  const skipAutoApply = opts && opts.skipAutoApply;
  const sizeDataEl = document.getElementById('SizeConversionData');
  if (!sizeDataEl) return;

  const sizeData = JSON.parse(sizeDataEl.textContent || '[]');
  const tabContainer = document.getElementById('DynamicSizeTabs');
  const sizeInput = document.getElementById('DisplayedSize');
  if (!tabContainer || !sizeInput || !sizeData.length) return;

  // Detect available systems dynamically from JSON keys
  const availableSystems = Object.keys(sizeData[0] || {});
  if (!availableSystems.length) return;

  // Build tabs using labels directly from JSON keys
  tabContainer.innerHTML = '';
  availableSystems.forEach((sys, i) => {
    const btn = document.createElement('button');
    btn.className = 'size-system-tab' + (i === 0 ? ' is-active' : '');
    btn.dataset.system = sys;
    btn.textContent = sys; // Use JSON label directly
    tabContainer.appendChild(btn);
  });

  // Scope to current product to prevent cross-product tab contamination
  const productKey = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || 'default';
  const storageKey = 'activeSizeSystem_' + productKey;

  // Default system = first key
  let currentSystem = sessionStorage.getItem(storageKey) || availableSystems[0];
  if (!availableSystems.includes(currentSystem)) {
    currentSystem = availableSystems[0];
  }

  // Build lookup map using the first system as the reference (not hardcoded to UK)
  const baseSystem = availableSystems[0];
  const map = {};
  sizeData.forEach(row => (map[row[baseSystem]] = row));

  // 🔹 Helper: write the correct note into sizeInput based on currentSystem
  function applySizeToInput(selected) {
    if (!selected) {
      sizeInput.value = '';
      return;
    }

    const baseVal = selected.value;
    const mapped = map[baseVal];

    if (currentSystem === baseSystem) {
      // Default system (e.g. UK): "UK 7"
      sizeInput.value = `${baseSystem} ${baseVal}`;
    } else {
      // Other system (e.g. US / EU): "US 8.5"
      const val = (mapped && mapped[currentSystem]) || baseVal;
      sizeInput.value = `${currentSystem} ${val}`;
    }
  }

  // Update visible size labels
  function updateLabels(system) {
    document.querySelectorAll('input[type="radio"][name^="Size"]').forEach(input => {
      const baseVal = input.value;
      const label = document.querySelector(`label[for="${input.id}"]`);
      const mapped = map[baseVal];
      if (!label) return;

      label.textContent = mapped && mapped[system] ? mapped[system] : baseVal;

      input.removeEventListener('click', handleSizeClick);
      input.addEventListener('click', handleSizeClick);
    });
  }

  // Handle size selection
  function handleSizeClick(e) {
    const input = e.target;
    applySizeToInput(input);
  }

  // Tab switching
  tabContainer.addEventListener('click', (e) => {
    const tab = e.target.closest('.size-system-tab');
    if (!tab) return;

    document.querySelectorAll('.size-system-tab').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    currentSystem = tab.dataset.system;
    sessionStorage.setItem(storageKey, currentSystem);
    updateLabels(currentSystem);

    // Refresh selected display after switching tabs
    const selected = document.querySelector('input[type="radio"][name^="Size"]:checked');
    applySizeToInput(selected);
  });

  // Activate correct tab
  document.querySelectorAll('.size-system-tab').forEach(tab => {
    tab.classList.toggle('is-active', tab.dataset.system === currentSystem);
  });

  updateLabels(currentSystem);

  // Only auto-apply on initial page load — skip after AJAX color swaps to prevent stale note
  if (!skipAutoApply) {
    const initiallySelected = document.querySelector('input[type="radio"][name^="Size"]:checked');
    applySizeToInput(initiallySelected);
  }
};

// ---- Init on load ----
if (document.readyState !== 'loading') {
  window.initSizeConversion();
} else {
  document.addEventListener('DOMContentLoaded', window.initSizeConversion);
}

// ---- Re-init on variant change ----
document.addEventListener('variant:change', () => {
  setTimeout(window.initSizeConversion, 50);
});

// ---- Re-init on section reload ----
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.product-form')) {
    setTimeout(window.initSizeConversion, 100);
  }
});

/* size conversion script product page requires two copies another one is in size-conversion.liquid - make sure same coding */

/* live countdown timer on card-product page (main-product-badges.liquid) */
(function () {
  if (window.__endsBadgeInit) return;
  window.__endsBadgeInit = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Compute server offset ONCE (works across AJAX swaps)
  function computeOffsetMs() {
    var el = document.querySelector(
      '.ends-badge[data-server-now], .starts-badge[data-server-now]'
    );
    if (!el) return 0;

    var serverNowSec = parseInt(el.getAttribute('data-server-now'), 10);
    if (isNaN(serverNowSec)) return 0;

    return (serverNowSec * 1000) - Date.now();
  }

  var offsetMs = computeOffsetMs();

  function nowCorrectedMs() {
    return Date.now() + offsetMs;
  }

  function tick() {
    // If AJAX injected new badges, recalc offset once
    if (!offsetMs) {
      var maybe = computeOffsetMs();
      if (maybe) offsetMs = maybe;
    }

    var nowMs = nowCorrectedMs();

    // Supports both "Live in" and "Ends in"
    document
      .querySelectorAll('.ends-badge[data-end-ts], .starts-badge[data-end-ts]')
      .forEach(function (el) {
        if (el.dataset.stopped === '1') return;

        var endSec = parseInt(el.getAttribute('data-end-ts'), 10);
        if (isNaN(endSec)) return;

        var diffMs = (endSec * 1000) - nowMs;

        // Finished → remove
        if (diffMs <= 0) {
          el.dataset.stopped = '1';
          el.remove();
          return;
        }

        var totalSec = Math.floor(diffMs / 1000);

        // NEW: include days if >= 24h
        var days = Math.floor(totalSec / 86400);
        var rem = totalSec % 86400;

        var h = Math.floor(rem / 3600);
        var m = Math.floor((rem % 3600) / 60);
        var s = rem % 60;

        var timeEl = el.querySelector('.ends-time');
        if (timeEl) {
          timeEl.textContent =
            (days > 0 ? (days + 'D ') : '') +
            pad(h) + ':' + pad(m) + ':' + pad(s);
        }
      });
  }

  tick();
  setInterval(tick, 1000);
})();
/* live countdown timer on card-product page */


/* product image custom swiper */
/**
 * Media Gallery (Main = Swiper, Thumbs = flex/overflow)
 * Usage:
 *  - On initial load: window.initMediaGallerySwipers();
 *  - After AJAX swap/replace HTML: window.initMediaGallerySwipers(containerElement);
 *
 * Notes:
 *  - Pass a container to limit re-init to that subtree (recommended for AJAX).
 *  - Prevents duplicate Swiper instances + duplicate listeners by storing refs on the gallery node.
 */
(function () {
  function initOneGallery(mediaGalleryEl) {
    if (!mediaGalleryEl) return;

    const sectionId = (mediaGalleryEl.id || '').replace('MediaGallery-', '');
    if (!sectionId) return;

    const root = mediaGalleryEl;
    const mainEl = root.querySelector('#Swiper-Main-' + sectionId);
    if (!mainEl) return;

    // Prevent double-init
    if (root.__mediaGalleryInited) {
      // If Swiper was destroyed externally, allow re-init
      if (root.__mediaGallerySwiper && !root.__mediaGallerySwiper.destroyed) return;
    }

    // Helpers to prevent tiny page jumps caused by focus/scroll settling
    function restorePageScroll(y) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
      });
    }

    function blurIfInsideGallery() {
      const ae = document.activeElement;
      if (ae && root.contains(ae)) ae.blur();
    }

    // THUMBS (no swiper)
    const thumbsWrap = root.querySelector('#GalleryThumbnails-' + sectionId);
    const thumbsTrack = thumbsWrap?.querySelector('.media-gallery-thumbs__track');
    const thumbs = thumbsTrack
      ? Array.from(thumbsTrack.querySelectorAll('.media-gallery-thumbs__item'))
      : [];

    // Avoid scrolling the page on initial load
    let hasUserInteracted = false;

    function setActiveThumbByIndex(idx, opts = {}) {
      if (!thumbs.length) return;

      const { scrollThumbs = true } = opts;

      thumbs.forEach((btn) => {
        const isActive = Number(btn.dataset.slideIndex) === idx;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (!scrollThumbs) return;

      const active = thumbs.find((btn) => Number(btn.dataset.slideIndex) === idx);
      if (active) {
        // Horizontal-only thumb visibility; should not scroll page vertically
        active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    // If a previous instance exists, destroy it before re-init (AJAX safety)
    if (root.__mediaGallerySwiper && !root.__mediaGallerySwiper.destroyed) {
      try {
        root.__mediaGallerySwiper.destroy(true, true);
      } catch (e) {}
    }

    // MAIN Swiper (loop ON)
    const main = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: root.querySelector('.media-gallery-swiper__nav--next'),
        prevEl: root.querySelector('.media-gallery-swiper__nav--prev'),
      },
      pagination: {
        el: root.querySelector('.media-gallery-swiper__pagination'),
        clickable: true,
      },
      on: {
        slideChange: function () {
          setActiveThumbByIndex(this.realIndex, { scrollThumbs: hasUserInteracted });
        },
        slideChangeTransitionEnd: function () {
          blurIfInsideGallery();
        },
      },
    });

    // Store refs for AJAX re-init / clean up
    root.__mediaGallerySwiper = main;
    root.__mediaGalleryInited = true;

    // Nav buttons: allow Swiper to handle clicks (do NOT preventDefault)
    const prevBtn = root.querySelector('.media-gallery-swiper__nav--prev');
    const nextBtn = root.querySelector('.media-gallery-swiper__nav--next');

    // Avoid duplicate listeners by marking nodes
    [prevBtn, nextBtn].forEach((b) => {
      if (!b || b.__mediaGalleryNavBound) return;
      b.__mediaGalleryNavBound = true;

      b.addEventListener('click', () => {
        hasUserInteracted = true;
        const y = window.scrollY;
        restorePageScroll(y);
        blurIfInsideGallery();
      });
    });

    // Click thumb -> main slide (use slideToLoop for loop mode)
    thumbs.forEach((btn) => {
      if (btn.__mediaGalleryThumbBound) return;
      btn.__mediaGalleryThumbBound = true;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        hasUserInteracted = true;

        const y = window.scrollY;
        const idx = Number(btn.dataset.slideIndex || 0);

        main.slideToLoop(idx, 0);
        setActiveThumbByIndex(idx, { scrollThumbs: true });

        restorePageScroll(y);
        blurIfInsideGallery();
      });
    });

    // Initial state: highlight correct thumb, but DO NOT scroll thumbs (prevents page jump)
    setActiveThumbByIndex(main.realIndex, { scrollThumbs: false });
  }

  function initAll(container) {
    const scope = container || document;
    scope.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach((mg) => initOneGallery(mg));
  }

  // Expose for AJAX re-init
  window.initMediaGallerySwipers = function (container) {
    initAll(container);
  };

  // Auto-init on load + theme editor section load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', () => initAll(document));
})();
/* product image custom swiper */